import dayjs from "@/lib/dayjs";

/**
 * 日付をフォーマットする
 * lib/dayjs.ts がTIMEZONEを処理済み
 *
 * @param date
 * @param format
 */
export function formatDate(
  date?: Date | string,
  format: string = "YYYY年M月D日",
): string {
  return dayjs(date).format(format);
}
